import { Facility } from '@reliance/types/models/Facility';
import React, { useCallback } from 'react';
import InmatesTable, { InmateListRow } from '../inmate/list/InmatesTable';

type FacilityInmatesTabProps = {
  facility: Facility;
};

const INMATE_COLUMNS = [
  'dateAdded',
  'status',
  'phoneStatus',
  'textStatus',
  'firstName',
  'lastName',
  'account',
  'device',
  'msgBalance',
];

const FacilityInmatesTab: React.FC<FacilityInmatesTabProps> = ({ facility }) => {
  const onDetails = useCallback(
    (inmate: InmateListRow) => {
      window.location.assign(`/inmates/view/${inmate.id}`);
    },
    []
  );

  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div>
        <InmatesTable
          initialFilters={{ facilityId: facility.id, status: 'Enabled' }}
          columns={INMATE_COLUMNS}
          notifyTabLoadingId="inmates"
          onDetails={onDetails}
        />
      </div>
    </div>
  );
};

export default FacilityInmatesTab;
